import React from "react";
import { useNavigate } from "react-router-dom";
import { FiLock } from "react-icons/fi";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";

const AccessDenied = () => {
  const navigate = useNavigate();
  return (
    <div className="flex bg-gray-100 min-h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Navbar />
        <div className="flex-1 flex flex-col items-center justify-center p-8 text-center">
          <div className="w-16 h-16 rounded-2xl bg-red-50 flex items-center justify-center mb-4">
            <FiLock size={28} className="text-red-400" />
          </div>
          <h2 className="text-xl font-bold text-gray-800 mb-1">Access Denied</h2>
          <p className="text-sm text-gray-400 max-w-sm mb-6">
            You don't have permission to view this page. Contact your Super Admin if you think this is a mistake.
          </p>
          <button
            onClick={() => navigate("/dashboard")}
            className="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
